// extracted by mini-css-extract-plugin
module.exports = {"summaryTitle":"Tasklist_summaryTitle__H4F_p","summaryBody":"Tasklist_summaryBody__2QZ3n"};